/*
 * @Date: 2021-3-23 14:39:51
 * @Author: WZ
 * @Description: 
 */
import CryptoJS from 'crypto-js' // 加密 or 解密

const secretKey = "ZniHsGZunPD43fKx"

export const AESUtil = {
  /**
   * AES加密方法
   * @param content 要加密的字符串
   * @returns {string} 加密结果
   */
  aesEncrypt: (content) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const srcs = CryptoJS.enc.Utf8.parse(content);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  /**
   * 解密方法
   * @param encryptStr 密文
   * @returns {string} 明文
   */
  aesDecrypt: (encryptStr) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypt = CryptoJS.AES.decrypt(encryptStr, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
}

/**
* 将复制的HTML表格字符串解析为对象数组，name包含-/-|为层级标记
* @param htmlString 密文
* @returns {Array} 数组
*/
export function parseTableData(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const rows = doc.querySelectorAll('tr');
  const result = [];
  const stack = []; // 用于跟踪当前层级
  
  rows.forEach(row => {
    const cells = row.querySelectorAll('td');
    if (cells.length >= 6) {
      // 获取第一列内容并计算层级
      const firstCellContent = cells[0].textContent.trim();
      const level = calculateLevel(firstCellContent);
      const name = extractName(firstCellContent);
      
      const type = cells[1].textContent.trim();
      const require = cells[2].textContent.trim();
      const normal = cells[3].textContent.trim();
      const describe = cells[5].textContent.trim();
      
      const node = {
        name: name,
        type: type,
        require: require,
        normal: normal,
        describe: describe ? `apiDocDesc.${describe}` : describe,
      };
      
      // 处理层级关系
      if (level === 0) {
        // 顶级节点
        result.push(node);
        stack.length = 0; // 清空栈
        stack.push({ node: node, level: level });
      } else {
        // 寻找父节点
        while (stack.length > 0 && stack[stack.length - 1].level >= level) {
          stack.pop();
        }
        
        if (stack.length > 0) {
          const parent = stack[stack.length - 1].node;
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push(node);
        } else {
          // 如果没有找到合适的父节点，作为顶级节点
          result.push(node);
        }
        
        stack.push({ node: node, level: level });
      }
    }
  });
  
  console.log('Parsed table data:', result);
  return result;
}

// 计算层级深度
function calculateLevel(content) {
  if (!content) return 0;
  
  // 匹配开头的 - 和 -| 组合
  const match = content.match(/^(\s*[-|]+\s*)*/);
  if (match && match[0]) {
    // 计算 - 的数量作为层级深度
    const dashCount = (match[0].match(/-/g) || []).length;
    return dashCount;
  }
  
  return 0;
}

// 提取真正的名称（去除层级标记）
function extractName(content) {
  if (!content) return '';
  
  // 移除开头的所有 -| 组合和空格
  return content.replace(/^(\s*[-|]+\s*)*/, '').trim();
}